
import {createSlice} from "@reduxjs/toolkit";


export const interestSearchSlice = createSlice({
    name: 'interestSearchSlc',
    initialState: {value: {
            idFrom: null,
            idTo: null,
            externalIdFrom: null,
            externalIdTo: null,
            rateDateFrom: null,
            rateDateTo: null,
            source: null,
            isActive: null
        }},
    reducers:

        {
            changeInterestSearch: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeInterestSearch } = interestSearchSlice.actions;

export default  interestSearchSlice.reducer ;

